import React from 'react';
import { Box, MusicNote, useBreakpoint, useHover } from '@landr/maestro';
import ArtworkComponent, {
    ArtworkProps,
} from 'components/CommonUi/Artwork/Artwork';
import {
    CardPlayer,
    PlayerActionsContainer,
} from 'components/Carousels/components/PreviewActions';

const Artwork: React.FC<ArtworkProps> = ({
    isLoading,
    isExclusive,
    isTakenDown,
    isRounded,
    imageUrl,
    alt,
    fallbackIcon = MusicNote,
    entity,
}) => {
    const isMobile = useBreakpoint('md');
    const [hoverRef, isHovered] = useHover(false);

    return (
        <Box
            width="100%"
            height="100%"
            display="flex"
            position="relative"
            ref={hoverRef}
        >
            <ArtworkComponent
                alt={alt}
                isLoading={isLoading}
                isExclusive={isExclusive}
                isTakenDown={isTakenDown}
                isRounded={isRounded}
                imageUrl={imageUrl}
                fallbackIcon={fallbackIcon}
                imageSize={isMobile ? 'default' : 'desktop'}
                loading="eager"
                entity={entity}
            />
            <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                overflow="hidden"
            >
                <PlayerActionsContainer isHovered={isHovered}>
                    {entity && <CardPlayer item={entity} />}
                </PlayerActionsContainer>
            </Box>
        </Box>
    );
};

Artwork.displayName = 'PageHeader.Artwork';

export default Artwork;
